import Vue from 'vue'
import moment from 'moment'


Vue.filter('date', function (date) {
  return moment(String(date)).format("DD-MM-YYYY")
})

Vue.filter('active', function (value) {
  return value === true ? 'Active' : 'Inactive';
})

Vue.filter('yesno', function (value) {
  return value === true ? 'Yes' : 'No';
})
Vue.filter('ififnot', function (value) {
  return value === true ? 'If' : 'If not';
})
Vue.filter('andor', function (value) {
  return value === true ? 'And' : 'Or';
})

Vue.filter('yesnocolor', function (value) {
  return value === true ? 'primary' : 'danger';
})

Vue.filter('formatSurveyType', function (value) {
  if (value === '0') {
    return 'Survey';
  } else if (value === '1') {
    return 'Quiz';
  } else if (value === '2') {
    return 'Checklist';
  } else if (value === '3') {
    return 'Venue Visit';
  } else if (value === '4') {
    return 'Online Training';
  }
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  const arr = value.split(' ')
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('formatWord', function (value) {
  if (!value || value === "") return ''
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
})

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('truncate', function (value, limit) {
  return value.substring(0, limit)
})

Vue.filter('tailing', function (value, tail) {
  return value + tail
})

Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value)).format('HH:mm')
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM-YYYY HH:mm')
  }
})

Vue.filter('time', function (value, is24HrFormat = false) {
  if (value) {
    const date = new Date(Date.parse(value))
    let hours = date.getHours()
    const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
    if (!is24HrFormat) {
      const time = hours > 12 ? 'AM' : 'PM'
      hours = hours % 12 || 12
      return `${hours}:${min} ${time}`
    }
    return `${hours}:${min}`
  }
})

Vue.filter('date', function (value, fullDate = false) {
  if (!fullDate) return moment(value).format("ll")
  else return moment(value).format("DD-MM-YYYY")
})

Vue.filter('month', function (val, showYear = true) {
  val = String(val)

  const regx = /\w+\s(\w+)\s\d+\s(\d+)./
  if (!showYear) {
    return regx.exec(val)[1]
  } else {
    return `${regx.exec(val)[1]} ${regx.exec(val)[2]}`
  }

})

Vue.filter('csv', function (value) {
  return value.join(', ')
})

Vue.filter('filter_tags', function (value) {
  return value.replace(/<\/?[^>]+(>|$)/g, '')
})

Vue.filter('k_formatter', function (num) {
  return num > 999 ? `${(num / 1000).toFixed(1)}k` : num
})
